import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import { vFocoAlerta } from "@/directives/focoAlerta";
import { vSelecionarAoFocar } from "@/directives/selecionarAoFocar";

import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/fontawesome-all.min.css";
import "@/assets/styles/styles.min.css";
import "@/assets/styles/auth.min.css";
import "@/assets/styles/ulemo-backoffice.min.css";

createApp(App)
  .use(router)
  .directive("foco-alerta", vFocoAlerta)
  .directive("selecionar-ao-focar", vSelecionarAoFocar)
  .mount("#app");
